var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2328)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99609 3.69141H23.2422C33.7305 3.69141 41.6797 9.33594 44.6289 17.5391H50V22.5H45.7617C45.8398 23.2812 45.8789 24.082 45.8789 24.9023V25.0195C45.8789 25.9375 45.8203 26.8359 45.7227 27.7148H50V32.6758H44.5312C41.5039 40.7617 33.6133 46.3477 23.2422 46.3477H5.99609V32.6758H0V27.7148H5.99609V22.5195H0V17.5195H5.99609V3.69141ZM10.8203 32.6367V41.8555H23.2422C30.8984 41.8555 36.6016 38.1641 39.2578 32.6367H10.8203ZM40.7227 27.6953H10.8203V22.5H40.7422C40.8594 23.3203 40.918 24.1602 40.918 25.0195V25.1367C40.8984 25.9961 40.8398 26.8555 40.7227 27.6953ZM23.2422 8.125C30.9375 8.125 36.6602 11.9141 39.2969 17.5195H10.8203V8.125H23.2422Z",
    fill: "#F4B731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6875 37.9687L42.3437 42.4219V25.4883L34.6875 37.9687Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3438 25.4883V42.4219L50 37.9687L42.3438 25.4883Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3438 34.5508L50 37.9688L42.3438 42.4219V34.5508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3437 34.5508V42.4219L34.6875 37.9688L42.3437 34.5508Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6875 39.3945L42.3437 50V43.8477L34.6875 39.3945Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3438 43.8477V50L50 39.3945L42.3438 43.8477Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.aada277923426bf10306689996d70234.svg";
export { ForwardRef as ReactComponent };